import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    window.addEventListener("type-preference-toggle:changed", this.handleChange)
  }

  disconnect() {
    window.removeEventListener("type-preference-toggle:changed", this.handleChange)
  }

  handleChange = (event) => {
    console.log("Type changed to:", event.detail.type)
    const selectedType = event.detail.type

    var updated = false
    const allContainers = this.element.querySelectorAll("[data-type]")
    allContainers.forEach((el) => {
      const type = el.dataset.type
      if (type === selectedType) {
        el.classList.remove("d-none")
      } else {
        el.classList.add("d-none")
        updated = true
      }
    })

    // if nothing was toggled, turn the first on
    if (!updated) { 
      const first = this.element.querySelector("[data-type]");
      if (first) {
        first.classList.remove("d-none")
      }
    }
  }
}
